import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    }
  },

  render
}
